// START_MODULE main_page
// START_CONTRACT
// PURPOSE: Compose the public landing page from the active community sections.
// OPERATIONAL_CONTEXT: Main route rendered after announcement and news data are loaded.
// CONTRACT: Show only maintained sections and preserve their navigation anchor order.
// KEYWORDS: landing, sections, announcements, news
// COMPLEXITY: 2
// END_CONTRACT
import React, { useEffect, useState } from 'react';

import Announcements from './sections/announcements/Announcements';
import Main from './sections/main/Main';
import Description from './sections/description/Description';
import GallerySection from './sections/gallery/Gallery';
import Statistics from './sections/statistics/Statistics';
import NewsSection from './sections/news/News';
import Contacts from './sections/contacts/Contacts';

import Spinner from 'components/atoms/spinner/Spinner';
import Navbar from 'components/organisms/navbar/Navbar';

import { IAnnouncement } from 'domain/entities/IAnnouncement';
import { INews } from 'domain/entities/INews';
import { mainRepository } from 'domain/repositories/MainRepository';

const MainPage: React.FC = () => {
  const [announcements, setAnnouncements] = useState<IAnnouncement[]>([]);
  const [news, setNews] = useState<INews[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const announcementsPromise = mainRepository.getAllAnnouncements();
    const newsPromise = mainRepository.getAllNews({ start: 0, finish: 7 });

    Promise.all([announcementsPromise, newsPromise])
      .then(([announcements, news]) => {
        setAnnouncements(announcements);
        setNews(news.news);
        setLoading(false);
      })
      .catch(() => {});
  }, []);

  if (loading) return <Spinner isCentered />;

  return (
    <>
      <Navbar />
      <Main />
      <Description />
      <Announcements announcements={announcements} />
      <GallerySection />
      <Statistics />
      <NewsSection news={news} />
      <Contacts />
    </>
  );
};

export default MainPage;
// END_MODULE main_page
